export function limitArrayToLength(arr, maxLength) {
  if (!arr || maxLength <= 0) return [];
  return arr.slice(0, maxLength);
}

export function remove(arr, index) {
  return arr.filter((_, i) => i !== index);
}
